import { getConfig } from '@/utils/config/config';
import { buildApiUrl, buildUrl } from '@/utils/url/build-url';
import { fetchApi } from '@/lib/fetcher';
import { getCookieValue, COOKIES } from '@/utils/cookies';
import { getBrazeDeviceId } from '@/utils/cookies/braze';

export type ReminderChannel = 'android' | 'desktop';

const getHeaders = async () => {
    const region = await getCookieValue(COOKIES.REGION);
    const brand = process.env.BRAND ?? '';

    return {
        'x-region-code': region,
        'x-brand': brand,
        accept: 'application/json'
    };
};

const getRemindersBaseUrl = () => {
    const config = getConfig();
    return buildApiUrl(config.apis.UserActivityClient);
};

export const apiSetReminder = async (gameId: string, value: boolean, channel: ReminderChannel): Promise<boolean> => {
    if (globalThis.window === undefined) {
        return false;
    }

    const baseUrl = getRemindersBaseUrl();
    const headers = await getHeaders();

    const queryParams: Record<string, string> = {
        product: process.env.PRODUCT ?? '',
        channel,
        gameId,
        value: value.toString()
    };

    if (channel === 'android') {
        const brazeDeviceId = await getBrazeDeviceId();
        if (brazeDeviceId) {
            queryParams.deviceId = brazeDeviceId;
        }
    }

    const url = buildUrl(`${baseUrl}/remind-me/add`, queryParams);

    try {
        const res = await fetchApi(url, { method: 'GET', headers, credentials: 'include' });
        const json = await res.json();
        return json?.success === true;
    } catch (e) {
        console.error('setReminder error:', e);
        return false;
    }
};
